import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import * as NotificationTemplateActions from './notification-template.action';
import { GeneralSignalRResponse } from "src/app/services/signal-r/general-signal-r-response";
import { SignalRService } from "src/app/services/signal-r/signal-r.service";
import { SignalRAction } from "src/app/services/signal-r/signalr-enums";
import { Channels } from "src/app/store/channels";

@Injectable({
  providedIn: 'root'
})
export class NotificationTemplateStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new NotificationTemplateActions.NotificationTemplateRefresh());
  }

  initListeners() {
    // NotificationTemplate
    this.signalRService.hubConnection?.on(Channels.NOTIFICATIONS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new NotificationTemplateActions.NotificationTemplateCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new NotificationTemplateActions.NotificationTemplateUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new NotificationTemplateActions.NotificationTemplateDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new NotificationTemplateActions.NotificationTemplateRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new NotificationTemplateActions.NotificationTemplateRefreshByID(data.id));

      }
    });

  }
}
